import styled from "styled-components";
import { device } from "../../../style";

export const Container = styled.div`
  padding: 0 22px;
  width: 100%;

  @media ${device.tablet} {
    padding: 0 30px;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  padding: 24px 16px;
  border-radius: 12px;
  border: 1px solid rgba(21, 106, 75, 0.65);
  background: rgba(0, 0, 0, 0.2);

  @media ${device.mobileXL} {
    padding: 30px;
    margin-bottom: 0px;
  }

  @media ${device.laptop} {
    margin: 0 auto;
    max-width: 1410px;
  }
`;
